<template>
  <div>
    <md-card>
      <md-card-header class="card-header">
        <div>Presión actual</div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-25">
              <span class="main-text">
                Ducto :
              </span>
              <span class="detail-text" v-if="this.site_info !== null">
               {{this.site_info.section_name}}
              </span>            
            </div> 
            <div class="md-layout-item md-size-30">
              <span class="main-text">
                Ubicación :
              </span>            
              <span class="detail-text" v-if="this.site_info !== null">
                <a target="_blank" rel="noopener noreferrer" :href="this.map_link">
                  {{this.site_info.site_lat}}, {{this.site_info.site_lon}}
                </a>               
              </span>            
            </div>    
            <div class="md-layout-item md-size-40">
              <span class="main-text">
                Ultima transmisión de datos :
              </span>            
              <span class="detail-text" v-if="this.site_info !== null">
                {{this.last_update}}            
              </span>            
            </div>           
        </div> 
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-25">
              <span class="main-text">
                Sitio :
              </span>
              <span class="detail-text" v-if="this.site_info !== null">
               {{this.site_info.site_name}}
              </span>            
            </div> 
            <div class="md-layout-item md-size-30">
              <span class="main-text">
                Presión actual :
              </span>            
              <span class="detail-text" v-if="this.site_info !== null">
                {{this.pressure + ' kg/cm2'}}              
              </span>            
            </div>             
        </div>         
      </md-card-content>
    </md-card>
    <div style="margin: 10px;">
      <div id="chart" v-if="this.isChartVisible">
        <apexchart ref="realtimeChart" type="line" height="350" :options="chartOptions" :series="series"></apexchart>
      </div>
      <md-empty-state v-if="this.isEmpty"
        md-rounded
        md-icon="warning"
        md-label="No hay datos"
        md-description="No hay datos disponibles en este momento, vuelva a intentar.">
      </md-empty-state>
    </div>
  </div>
</template>

<script>
var $ = require('jquery')

export default {  
  data() {
    return {
      section: null,
      site: -1,
      site_info: null,
      map_link: '',
      isEmpty: false,
      isChartVisible: true,
      last_report_data_id: -1,
      timer: null,
      reportData: [],
      pressure: '',
      last_update: '',
      series: [{
        name: '',
        data: [],
      }],
      chartOptions: {
        noData: {
          text: 'Cargando...'
        },             
        chart: {
          type: 'line',
          width: '100%',
          height: 'auto',
          zoom: {
            type: 'x',
            enabled: false,
          },
          toolbar: {
            autoSelected: 'zoom'
          },
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 1000
            }
          },       
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 1.9,
        },        
        title: {
          text: '',
          align: 'left'
        },
        markers: {
          size: 0,
        },      
        theme: {
          monochrome: {
            enabled: true,
            color: '#1976bc',
            shadeTo: 'dark',
            shadeIntensity: 0.65
          }
        },          
        yaxis: {
          forceNiceScale: true,
          tickAmount: 6,
          logarithmic: true,
          title: {
              text: '',
          },
        },
        xaxis: {
          type: 'category',
          tickAmount: 4,
          tooltip: {
              enabled: false,
          },  
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false,
            hideOverlappingLabels: true,
            showDuplicates: false,           
          },      
          axisTicks: {
            show: true,             
          },
        },
      },
    }
  },
  methods: {
    loadDecimation() {
      this.$store.dispatch('LOAD_DECIMATION', {
        section: this.section,
        site: this.site
      }).then(resp => {
        // console.log(resp);
        if(resp.data === null || resp.data.length === 0) {
          this.isEmpty = true;
          this.isChartVisible = false;
          return;
        }
        let size = resp.data.length;
        this.last_report_data_id = resp.data[size - 1].report_data_id;
        // console.log('last_report_data_id : ' + this.last_report_data_id);
        var chartData = resp.data.map(q => ({x: q.report_date, y: q.data}));
        this.addChartData(chartData);
        this.timer = setInterval(this.loadDecimationStep, 500);
      });
    },
    loadDecimationStep() {
      clearInterval(this.timer);
      this.$store.dispatch('LOAD_DECIMATION_STEP', {
        section: this.section,
        site: this.site,
        report_data_id: this.last_report_data_id,
      }).then(resp => {
        // console.log(resp);
        // console.log('loadDecimationStep response');
        if(resp.data === null || resp.data.length === 0) {
          this.timer = setInterval(this.loadDecimationStep, 30000);
          return;
        }
        let size = resp.data.length;
        this.last_report_data_id = resp.data[size - 1].report_data_id;
        // console.log('last_report_data_id : ' + this.last_report_data_id);
        var chartData = resp.data.map(q => ({x: q.report_date, y: q.data}));
        this.addChartData(chartData);
        this.timer = setInterval(this.loadDecimationStep, 500);
      });      
    },
    addChartData(newChartData) {
      // console.log('add chart new ' + newChartData.length);
      this.reportData = this.reportData.concat(newChartData);
      // console.log('add chart data concat : ' + this.reportData.length);

      if(this.reportData.length > 2400) {
        this.reportData = this.reportData.slice(200, this.reportData.length);
      }
      // console.log('add chart total : ' + this.reportData.length);
      var last = this.reportData[this.reportData.length - 1];
      // console.log(last);
      this.last_update = last.x;
      this.pressure = last.y;

      this.series = [{
        data: this.reportData,
      }];
    },
  },
  created() {   
    this.section = this.$route.params.section;
    this.site = this.$route.params.site;

    this.$store.dispatch('LOAD_SITE_INFO', {section: this.section, site: this.site})
    .then(resp => {
      this.site_info = resp.data[0];
      // this.last_update = this.site_info.insert_timestamp;
      // this.pressure = this.site_info.rtu_pressure;
      // console.log(this.site_info);
      this.map_link = `https://maps.google.com?q=${this.site_info.site_lat},${this.site_info.site_lon}`;
      this.chartOptions.title.text = `PRESION DUCTO ${this.site_info.section_name} ${this.site_info.site_name}`;
      this.loadDecimation();
    });
  },
  beforeDestroy () {
    clearInterval(this.timer);
  }    
}

</script>

<style lang="scss" scoped>

  .md-card {
    background: rgb(247, 247, 247);
  }

  .card-header {
    font-size: large;
    font-weight: bold;
  }

  .main-text {
    font-weight: bold;
    font-size: small;
  }

  .detail-text {
    font-size: small;
  }

  .md-empty-state.md-theme-default.md-rounded {
    background-color: var(--no-data-background-color)
  }

</style>



// WEBPACK FOOTER //
// sitio.vue?1f768634